import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    FETCH_TIMESHEET: 'FETCH_TIMESHEET'
  })
};

export const fetchTimesheet = createAsyncAction(types.FETCH_TIMESHEET, () =>
  api.get(`v1/timesheet-header`).then((res) => res.data)
);

export const addFormRow = (date) => ({ type: 'ADD', payload: date });

export const deleteFormRow = (date, index) => ({ type: 'DELETE', payload: { date, index } });
